/* =========================================================
 * AdRenderer
 * Google Adsense等の広告を表示するComponent
========================================================= */
import React from 'react';

const AdRenderer = ({slot=null, html=null, className=''}={}) => {
  const uniqID = Math.random().toString(32).substring(2);

  if (html == null) {
    return (
      <div id={uniqID}>
        <div className={`p_adZone ${className}`} id={`div-gpt-ad-${slot}`}></div>
      </div>
    )
  } else {
    return (
      <div id={uniqID} dangerouslySetInnerHTML={{ __html: html }} />
    )
  }

}

export default AdRenderer;